<template>
  <div class="login-page" data-test="login__page">
    <div class="infos-login-page" >
      <el-alert
      title="information"
      type="info"
      :closable="false"
      description="En cas de première connexion ou de mot de passe oublié,
      rendez-vous dans l'application Mon Compte en cliquant sur le lien ci-dessous"
      show-icon>
      </el-alert>
      <el-link
        :href="getLink()"
        target="_blank"
        type="primary">
        Application Mon Compte<i class="el-icon-user-solid el-icon--right"></i>
      </el-link>
    </div>
        <Users :users="getAllUsers"
        v-loading="loader"
        element-loading-text="Chargement des utilisateurs..."
        @authTry="loginWithCredentials($event)"></Users>
        <!-- element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)" -->
  </div>
</template>

<script>
import Users from '@/components/Users/Users.vue';

const ls = require('local-storage');

export default {
  components: {
    Users,
  },
  data() {
    return {
      loader: true,
    };
  },
  mounted() {
    return this.$store.dispatch('auth/GetAllUsers')
      .then(() => {
        this.loader = false;
      });
  },
  computed: {
    getAllUsers() {
      return this.$store.getters['auth/userList'];
    },
  },
  methods: {
    async loginWithCredentials(cred) {
      // this.loading = true;
      try {
        this.$mixpanel.track('Connexion (succès)', {
          app: 'inventaire',
          username: cred.mail,
          userAgent: navigator.userAgent,
          screenHeight: window.screen.height,
          screenWidth: window.screen.width,
        });
        await this.$store.dispatch('auth/loginWithCredentials', {
          username: cred.mail,
          password: cred.password,
        });
        await this.$store.dispatch('auth/fetchCurrentUserProfile');
        await this.$store.dispatch('shopAuth/updateShop');
        this.showSuccessMessage();
        return this.$router.push({ name: 'Dashboard' });
      } catch (e) {
        this.$mixpanel.track('Connexion (erreur)', {
          app: 'inventaire',
          username: cred.mail,
          userAgent: navigator.userAgent,
          screenHeight: window.screen.height,
          screenWidth: window.screen.width,
        });
        console.log(e);
        return this.showErrorMessage(e.code);
      }
      // this.loading = false;
    },
    showSuccessMessage() {
      this.$message({
        type: 'success',
        message: this.$t('loginPage.successMessage'),
      });
    },
    showErrorMessage(codeError) {
      if (codeError === 'auth/wrong-password') {
        this.$message({
          type: 'error',
          message: this.$t('loginPage.errorPassword'),
        });
      } else if (codeError === 'auth/user-disabled') {
        this.$message({
          type: 'error',
          message: this.$t('loginPage.userDisabled'),
        });
      } else {
        this.$message({
          type: 'error',
          message: this.$t('commons.defaultErrorMessage'),
        });
      }
    },
    getLink() {
      const shopToken = ls.get('shopToken');
      return `https://moncompte-outils.marieblachere.fr/magic-link-verification?token=${shopToken}`;
    },
  },
};
</script>

<style>
.infos-login-page {
  width: 50%;
  margin: 50px;
}
.el-alert__title {
    font-size: 18px;
}
.el-alert .el-alert__description {
    font-size: 14px;
}
</style>

<style lang="stylus" scoped>
  @import '../../assets/css/main.styl';

  .login-page {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .login-card {
    width: 450px;
    padding: 40px 32px;
  }

  .login-card__header {
    text-align: center;
  }

  .login-title {
    color: $primary-color;
    position: relative;
    font-size: 2.3em;
    font-weight: 600;
    text-align: center;
    display: inline;
  }

  .infos-login-page {
    text-align: center;
  }
</style>
